import React from 'react'
import { Tab, Nav } from 'react-bootstrap'
import { tabData } from './constant'

const TabStatus = ({ setStatus, status, setCurrentPage }) => {
  const handleOnClick = (value) => {
    setCurrentPage(1)
    setStatus(value)
  }

  return (
    <Tab.Container defaultActiveKey={tabData[0].value}>
      <Nav as="ul" className="nav-pills mb-4 light">
        {tabData.map((data, i) => {
          return (
            i !== tabData.length && (
              <Nav.Item as="li" key={i}>
                <Nav.Link className={status === data.value ? 'active' : ''} onClick={() => handleOnClick(data.value)}>
                  {data.title}
                </Nav.Link>
              </Nav.Item>
            )
          )
        })}
      </Nav>
    </Tab.Container>
  )
}

export default TabStatus
